import { render, staticRenderFns } from "./formMarket.vue?vue&type=template&id=028fd0ca"
import script from "./formMarket.vue?vue&type=script&lang=js"
export * from "./formMarket.vue?vue&type=script&lang=js"
import style0 from "./formMarket.vue?vue&type=style&index=0&id=028fd0ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports